<template>
  <md-toolbar md-elevation="0" class="md-transparent">
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">{{ $route.name }}</h3>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse" >
          <div class="md-autocomplete" style="display:none;">
            <md-autocomplete
              class="search"
              v-model="selectedEmployee"
              :md-options="employees"
            >
              <label>Search...</label>
            </md-autocomplete>
          </div>
          <md-list>
            <md-list-item href="#/dashboard">
              <i class="material-icons">dashboard</i>
              <p class="hidden-lg hidden-md">Dashboard</p>
            </md-list-item>

             <md-list-item href="#/info?insession=1">
              <i class="material-icons">info</i>
              <p class="hidden-lg hidden-md">Info</p>
            </md-list-item>

            <md-list-item href="mailto:info@mymemry.com">
              <a href="mailto:info@mymemry.com"><i class="material-icons">email</i></a>
              <p class="hidden-lg hidden-md">email</p>
            </md-list-item>

            <li class="md-list-item">
              <a
                
                class="md-list-item-router md-list-item-container md-button-clean dropdown"
              >
                <div class="md-list-item-content">
                  <drop-down>
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <md-icon>notifications</md-icon>
                      <!--<span class="notification">5</span>-->
                      <p class="hidden-lg hidden-md">Notifications</p>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      
                      <li><a style="font-weight:bold;">COMING SOON</a></li>
                       <li><a>Email reminders</a></li>
                       <li><a>Pretty progress charts and stats</a></li>
                       <li><a>Mobile App</a></li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>

            <md-list-item > <!-- href="#/user" -->
              <i class="material-icons">person</i>
               <p v-if="session != null">{{session.firstname + ' ' + session.lastname}}</p>
              <p class="hidden-lg hidden-md">Profile</p>
            </md-list-item>
          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import ApiService from "@/services/api.service";

export default {
  data() {
    return {
      selectedEmployee: null,
      employees: [
       
      ],
      session : null
    };
  },
  mounted() {
    this.getSession();
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    getSession() {
        ApiService.getSession().then((res) => {
            console.log('Session',res);
            if(res.data)
              this.session = res.data;
        })
    }
  }
};
</script>

<style lang="css"></style>
